import { ShieldAlert } from "lucide-react";

import { Badge } from "@/components/ui/badge";

interface Props {
  direction: "input" | "output";
  count: number;
  categories: string[];
}

/**
 * Badge inline renderizada no ChatStream quando o backend emite
 * ``event:pii_detected``. Nao bloqueia o fluxo; so sinaliza ao usuario
 * que tipo de PII foi mascarada.
 */
export function PiiBadge({ direction, count, categories }: Props) {
  const label =
    direction === "input"
      ? `PII detectada no input (${count})`
      : `PII detectada na resposta (${count})`;
  return (
    <div className="inline-flex items-center gap-1 rounded-md border border-yellow-300 bg-yellow-50 px-2 py-1 text-xs text-yellow-800">
      <ShieldAlert className="h-3 w-3" />
      <span className="font-medium">{label}</span>
      {categories.length > 0 ? (
        <span className="flex gap-1">
          {categories.map((c) => (
            <Badge key={c} variant="outline" className="text-[10px]">
              {c}
            </Badge>
          ))}
        </span>
      ) : null}
    </div>
  );
}
